import React from 'react';
import styled from 'styled-components';

export const Lines = styled.div<{ $lastItem: boolean }>`
  width: 24px;
  height: 24px;
  position: relative;
  margin: 0 5px;

  &:after {
    content: '';
    position: absolute;
    border-right: 1px rgba(255, 255, 255, 0.2) solid;
    height: 41px;
    height: ${({ $lastItem }) => $lastItem && '12px'};
    width: 24px;
    transform: translateX(-50%);
  }

  &:before {
    content: '';
    position: absolute;
    border-bottom: 1px rgba(255, 255, 255, 0.2) solid;
    height: 24px;
    width: 12px;
    transform: translateY(-50%) translateX(100%);
  }
`;

export const SelectItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  margin: 0 22px;

  p {
    color: ${({ $isSelected, theme }) => ($isSelected ? theme.palette.primary.light : 'rgba(255,255,255,0.7)')};
    font-size: 14px;
    font-weight: 400;
    margin: 10px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }

  &:hover {
    background: ${({ theme }) => theme.sidebar.itemHover};
    border-radius: 5px;
  }
`;

export const SubItem = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`;
export const SubItemTitle = styled.p<{ $isSelected: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.7)')};
  font-size: 14px;
  letter-spacing: 0.4px;
  margin: 0 6px;
`;

export const EmptyText = styled.span`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
  padding: 4px 8px 4px 34px;
  display: block;
`;

export const MainContainer = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0 10px;
  background: ${({ $selected, theme }) => ($selected ? theme.sidebar.itemSelected : '')};
  &:hover {
    cursor: pointer;
    background: ${({ $selected, theme }) => ($selected ? theme.sidebar.itemSelected : theme.sidebar.itemHover)};
  }
`;
